jQuery.bind = function(object, method) {
    var args = Array.prototype.slice.call(arguments, 2);
    return function() {
        var args2 = [this].concat(args, $.makeArray(arguments));
        return method.apply(object, args2);
    };
};
(function($) {
    SexyLightbox = {
        getOptions: function() {
            return {
                find: 'sexylightbox'
            };
        },
        initialize: function(options) {
			this.options = $.extend(this.getOptions(), options);
			this.refresh();
			eModal.setEModalOptions({
				loadingHtml: '<h5>Yükleniyor...</h5><div class="progress"><div class="progress-bar progress-bar-striped active" style="width: 100%"></div></div><script>$("div.progress").parent().css("height", "auto");</script>',
				title: 'Bilgi'
			});
			return;
        },
        hook: function(enlace) {
            enlace = $(enlace);
            enlace.trigger('blur');
            this.show((enlace.attr("title") || enlace.attr("name") || ""), enlace.attr("href"), (enlace.attr('rel') || false));
        },
        close: function() {
            eModal.close();
        },
        refresh: function() {
            var self = this;
            this.anchors = [];
            $("a, area").each(function() {
                if ($(this).attr('rel') && new RegExp("^" + self.options.find).test($(this).attr('rel'))) {
                    $(this).on('click', function(event) {
                        event.preventDefault();
                        self.hook(this);
                    });
                    $(this).on('contextmenu', function() {
                        return false;
                    });
                    if (!($(this).attr('id') == self.options.name + "-Left" || $(this).attr('id') == self.options.name + "-Right")) {
                        self.anchors.push(this);
                    }
                }
            });
			if (window.PM) {
				(function(sexy){
					window.PM.on("ready.iframe", function(_window){
						if(!PM.IsMobile()) sexy.refreshBox(_window);
					});
				})(this);
			}
        },
        show: function(caption, url, rel, force) {
            var baseURL = url.match(/(.+)?/)[1] || url;
            var imageURL = /\.(jpe?g|png|gif|bmp)/gi;
            var queryString = url.match(/\?(.+)/);
            if (queryString) queryString = queryString[1];
            var params = this.parseQuery(queryString);
            params = $.extend({}, {
                'width': 0,
                'height': 0,
                'modal': 1,
                'background': '',
                'title': caption
            }, params || {});
            params['width'] = parseInt(params['width']);
            params['height'] = parseInt(params['height']);
            params['modal'] = parseInt(params['modal']);
            if (force == 'image' || baseURL.match(imageURL)) {
                this.img = new Image();
                eModal.alert(this.img, params.title);
				this.img.onload = $.bind(this, function() {
                    params['width'] = this.img.width;
					params['height'] = this.img.height;
                });
                this.img.onerror = $.bind(this, function() {
					this.show('', this.options.imagesdir + '/' + this.options.color + '/404.png', this.options.find);
                });
                this.img.src = url;
            } else {
                if (url.indexOf('TB_inline') != -1) {
					eModal.alert($('#' + params['inlineId']).html(), params.title);
                } else if (url.indexOf('TB_iframe') != -1) {
                    var urlNoQuery = url.split('TB_');
					this.showIframe(urlNoQuery[0], params);
                } else {
					(function(sexy, params, url){
						eModal
							.ajax({url: url, buttons: false, title: params.title})
							.then(function($modal){
								var _window = $modal[0];
								params["width"] = params["width"] + 30;
								params["height"] = params["height"] + 30;
								sexy.refreshBox(_window, params);
							});
					})(this, params, url);
                }
            }
        },
		resize: function(w, h, _modal) {
			var _base = _modal || $("body");
			if (w) _base.find(".modal-dialog").css("width", w.toString() + "px");
			if (h) {
				if (_base.find(".modal-dialog .modal-content iframe").length > 0) return _base.find(".modal-dialog .modal-content iframe").css("height", h + "px");
				_base.find(".modal-dialog .modal-content div:eq(1)").css("height", h + "px");
			}
		},
		refreshBox: function(_window, params) {
			var _base = _window.document || _window;
			if ($(_base).find("title, .baslik").length > 0) {
				var title = $(_base).find("title, .baslik").first().text();
				this.title(title);
				$(_base).find("title, .baslik").remove();
			}
			if ($(_base).find(".modal-footer").length > 0) $(_base).find(".modal-footer").remove();
			var size = {};
			if (params && params.width) size["width"] = params.width;
			if (params && params.height) size["height"] = params.height;
			if ($(_base).find("meta[name='modal-width']")[0]) size["width"] = parseInt($(_base).find("meta[name='modal-width']").attr("content"), 10);
			if ($(_base).find("meta[name='modal-height']")[0]) size["height"] = parseInt($(_base).find("meta[name='modal-height']").attr("content"), 10);
			this.resize(size.width, size.height, _window.document ? undefined : $(_window));
		},
		title: function(_title) {
			$(".modal-dialog .modal-title").html(_title);
		},
        showIframe: function(src, params) {
			(function(sexy, params, src){
				eModal
					.iframe({url: src, title: params.title, buttons: false})
					.then(function(){
                        var _iFrame = $("iframe[src='" + src + "']");
                        _iFrame.css("border-radius", "0 0 6px 6px");
						_iFrame[0].contentWindow.parentIFrame = _iFrame[0];
						_iFrame[0].contentWindow.parentIFrameParams = params;
					});
			})(this, params, src);
        },
        parseQuery: function(query) {
            if (!query)
                return {};
            var params = {};
            var pairs = query.split(/[;&]/);
            for (var i = 0; i < pairs.length; i++) {
                var pair = pairs[i].split('=');
                if (!pair || pair.length != 2)
                    continue;
                params[unescape(pair[0])] = unescape(pair[1]).replace(/\+/g, ' ');
            }
            return params;
        },
        shake: function() {
			console.log("shake called");
			return;
        },
        boyutla: function(w, h) {
			console.log(arguments);
			return;
			this.resize(w, h);
        }
    }
})(jQuery);